export default class UpdateSecondaryWalletSettingsRequest {
    overridable: boolean = false;
}